import { ReactNode } from "react";

export interface PageHeaderProps {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  className?: string;
}

/**
 * Standardized PageHeader shared component across all workspace pages.
 * Matches Figma EL-ed328246 layout & height:
 * - 24px SemiBold title (#011627)
 * - 16px Regular subtitle (#7F8A92)
 * - Standardized min-height (96px) ensures seamless consistency between pages
 * - Actions aligned on the right without shifting header baseline
 */
export function PageHeader({ title, subtitle, actions, className = "" }: PageHeaderProps) {
  return (
    <div
      className={`min-h-[76px] flex flex-col sm:flex-row sm:items-start justify-between gap-4 pt-1 mb-4 font-sans ${className}`}
    >
      <div className="flex flex-col gap-1 min-w-0">
        <h1 className="text-2xl font-semibold text-[#011627] tracking-tight font-display leading-tight">
          {title}
        </h1>
        {subtitle && (
          <p className="text-base text-[#7F8A92] font-normal leading-normal">
            {subtitle}
          </p>
        )}
      </div>
      {actions && (
        <div className="flex items-center gap-3 shrink-0">
          {actions}
        </div>
      )}
    </div>
  );
}
